import { render, staticRenderFns } from "./Duels.vue?vue&type=template&id=39627fb0&scoped=true"
import script from "./Duels.vue?vue&type=script&lang=js"
export * from "./Duels.vue?vue&type=script&lang=js"
import style0 from "./Duels.vue?vue&type=style&index=0&id=39627fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39627fb0",
  null
  
)

export default component.exports